import { FormControlLabel, Checkbox } from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';
import { WsTypography } from 'wisestep-base';

interface CheckboxFilterProps {
  name: string;
  label: string;
  onClick?: (value: boolean) => void;
  bold?: boolean;
  required?: boolean;
  disabled?: boolean;
  size?: 'small' | 'medium';
}

const WsCheckBox = ({
  name,
  label,
  onClick,
  bold = false,
  required = false,
  disabled = false,
  size,
}: CheckboxFilterProps) => {
  const { control } = useFormContext();
  const formattedLabel = bold ? <WsTypography bold={true}>{label}</WsTypography> : label;

  return (
    <FormControlLabel
      disabled={disabled}
      control={
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Checkbox
              {...(size && { size })}
              {...(required && { required })}
              disabled={disabled}
              checked={field.value}
              onChange={(e) => {
                field.onChange(e.target.checked);
                onClick && onClick(e.target.checked);
              }}
            />
          )}
        />
      }
      label={formattedLabel}
    />
  );
};
export default WsCheckBox;
